import Swiper from "@modules/swiper";
import { Navigation, Pagination, A11y, Keyboard } from "@modules/swiper/modules";

// import '@modules/swiper/css';
// import "@modules/swiper/css/a11y";
// import "@modules/swiper/css/keyboard";
// import "@modules/swiper/css/navigation";
// import "@modules/swiper/css/pagination";
import $ from "@modules/jquery";
var language = document.getElementsByTagName("html")[0].getAttribute("lang");
var SlideMessagePrev = language === "it" ? "Mostra immagine precedente" : "Vorheriges Bild anzeigen";
var SlideMessageNext = language === "it" ? "Mostra immagine successiva" : "Nächstes Bild anzeigen";
export default () => {
	const swiperElementRelatedProduct = document.querySelector(".slide-related-product");
	console.log("entra");
	if (swiperElementRelatedProduct) {
		console.log("ESISTE");
		// Crea l'istanza del Swiper
		const RelatedProduct= new Swiper(swiperElementRelatedProduct, {

			modules: [Navigation, Pagination, A11y, Keyboard],
			slidesPerView: 1.2,
			spaceBetween: 10,
			slideToClickedSlide: true,

			pagination: {
				el: ".swiper-pagination",
				type: "progressbar",
				enabled: true
			},
			 a11y: {
                prevSlideMessage: SlideMessagePrev,
                nextSlideMessage: SlideMessageNext,
            },
			keyboard: {
				enabled: true,
				onlyInViewport: true,
				pageUpDown: true,
			},
			grabCursor: true,
			navigation: {
				prevEl: ".arrow-left-related",
				nextEl: ".arrow-right-related",

			},
			breakpoints: {
				640: {
					slidesPerView: 2.1,
					spaceBetween: 30

				},
				800: {
					slidesPerView: 2.4,
					spaceBetween: 30

				},
				1200: {
					slidesPerView: 3,
					spaceBetween: 30
				},
				
			},
		});
	

	}
	
};

    

